import { Fragment, useContext, useEffect, useRef, useState } from "react";
import React from "react";
import { InstantSearch, Configure } from "react-instantsearch";
import { BreadCrumb } from "../../Layout/Common/breadCrumb";
import {
  ApplyDisjunctiveFiltersFromUrl,
  getInitialSortByUiState,
  ResetFiltersOnQueryChange,
  UseCaptureFacets,
  UseSearchStats,
} from "../../Layout/Common/algoliaInstantLib";
import { decodeFilters, isValidArray } from "../../Layout/Common/common";

import { SelectedFilterMobileLite } from "../algolia/selectedFilterMobile";
import { SoryByOption } from "../algolia/sortbyOption";
import { SoryByOptionMobile } from "../algolia/sortbyOptionMobile";
import { SelectedFilterLite } from "../algolia/selectedFilter";
import { FacetFilterLite } from "../algolia/facetFilter";
import { FilterContainerMobileLite } from "../algolia/filterContainerMobile";
import { CustomInfiniteHitsLite } from "../algolia/customInfiniteHits";
import { SearchResultContainer } from "../PowerSearchLite/searchResutlContainer";
import { useLocation, useParams } from "react-router-dom";
import { PAGES } from "../../routeConfig";
import { GlobalContext } from "../../Context/GlobalContext";
import algoliasearch from "algoliasearch";

const searchClient = algoliasearch(
  `${process.env.REACT_APP_ALGOLIA_APP_ID}`,
  `${process.env.REACT_APP_ALGOLIA_SEARCH_KEY}`,
);

const indexName = `${process.env.REACT_APP_ALGOLIA_INDEX_NAME}`;
const newproductindexName = `${process.env.REACT_APP_ALGOLIA_NEWPRODUCT_INDEX_NAME}`;

export const ProductPageAlgolia = () => {
  const [sideFilterClicked, setSideFilterClicked] = useState(false);
  const [facetFilters, setFacetFilters] = useState(null);
  const [searchString, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [defaultFilter, setDefaultFilter] = useState("");
  const location = useLocation();
  const { algoliaProducts } = useContext(GlobalContext);

  useEffect(() => {
    if (location.pathname.includes(PAGES.SPECIALPRODUCT)) {
      setSearch(`Special Products`);
      setDefaultFilter("IsProductSpecial:1");
    } else if (location.pathname.includes(PAGES.FEATUREDPRODUCTS) && algoliaProducts["TRENDINGPRODUCTS"]) {
      setSearch(`Featured Products`);
      let productList = algoliaProducts["TRENDINGPRODUCTS"];
      let skuList = productList.map((i) => `sku:${i.sku}`);
      setDefaultFilter(skuList.join(" OR "));
    }
    setFacetFilters(null);
    setSideFilterClicked(false);
  }, [location.pathname, algoliaProducts]);

  return (
    <Fragment>
      <BreadCrumb data={[{ name: searchString, url: "" }]} />

      <section className="filter-product-section">
        <InstantSearch
          searchClient={searchClient}
          indexName={indexName}
          initialUiState={getInitialSortByUiState(indexName)}
        >
          <Configure query={query} hitsPerPage={300} maxValuesPerFacet={100} filters={defaultFilter} />
          <ResetFiltersOnQueryChange query={query} />
          {isValidArray(facetFilters) && <ApplyDisjunctiveFiltersFromUrl />}
          <div className="container-fluid container-lg">
            <SearchResultContainer search={searchString} />

            <div className="row mt-3">
              <div className="col-lg-12">
                <div className="filterHead-wrapper filterHead-wrapperWeb">
                  <div className="filterbtn-left">
                    <button
                      className="btn"
                      id="searchFilter-btn"
                      onClick={() => setSideFilterClicked(!sideFilterClicked)}
                    >
                      <span className="wes-searchfilter" />
                      {sideFilterClicked ? "Hide Filters" : "Filter"}
                    </button>
                    <UseSearchStats />
                  </div>
                  <SoryByOption indexName={indexName} />
                </div>
                <div className="filterHead-wrapper filterHead-wrapperMob">
                  <FilterContainerMobileLite items={facetFilters} />
                  <SoryByOptionMobile />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className={`filter-product-wrapper ${sideFilterClicked ? "filter-product-wrapperHide" : ""}`}>
                  {/* Left side Filters */}
                  <div className={`filter-wrapper filter-wrapperWeb  mt-2 ${sideFilterClicked ? "filtersWeb" : ""}`}>
                    <div className="accordion filters-accordion accordion-flush" id="filterAccordion">
                      {isValidArray(facetFilters) && <SelectedFilterLite />}
                      {/* In Stock */}
                      {/* <div className="accordion-item inStock">
                        <label className="filterSwitch">
                          <input type="checkbox" />
                          <span className="slider" />
                        </label>
                        <p>In Stock Only (1.5K)</p>
                      </div> */}
                      {/* <FitMyDeviceFilter /> */}
                      <FacetFilterLite attribute={"category"} limit={30} showMore={true} sortBy={["count:desc"]} />
                      {isValidArray(facetFilters) ? (
                        <Fragment>
                          {facetFilters.map((Item, index) => (
                            <FacetFilterLite
                              attribute={`prodSpecs.${Item}`}
                              limit={30}
                              showMore={true}
                              sortBy={["count:desc"]}
                            />
                          ))}
                        </Fragment>
                      ) : (
                        <div className="accordion-item">loading..</div>
                      )}
                      {!isValidArray(facetFilters) && <UseCaptureFacets setFacets={setFacetFilters} />}
                    </div>
                  </div>
                  <div className={`ct-filter-product ${sideFilterClicked ? "filterProducts" : "active"}`}>
                    {isValidArray(facetFilters) && <SelectedFilterMobileLite />}

                    <div className="row row-spacing row-equal"></div>
                    <CustomInfiniteHitsLite catFilter={false} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </InstantSearch>
      </section>
    </Fragment>
  );
};
